__turbopack_context__.v({
  "AccountItem": "sidebar-navigation-module__1-Aj5a__AccountItem",
  "Active": "sidebar-navigation-module__1-Aj5a__Active",
  "Button": "sidebar-navigation-module__1-Aj5a__Button",
  "Container": "sidebar-navigation-module__1-Aj5a__Container",
  "Item": "sidebar-navigation-module__1-Aj5a__Item",
  "List": "sidebar-navigation-module__1-Aj5a__List",
  "Login": "sidebar-navigation-module__1-Aj5a__Login",
  "Root": "sidebar-navigation-module__1-Aj5a__Root",
  "Sublist": "sidebar-navigation-module__1-Aj5a__Sublist",
  "slideDown": "sidebar-navigation-module__1-Aj5a__slideDown",
  "slideUp": "sidebar-navigation-module__1-Aj5a__slideUp",
});
